export enum InventoryType {
	SHOPIFY = 'SHOPIFY',
	CSV = 'CSV',
}
